import React, { FC } from 'react';

import {
  Box,
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSelectInput from 'components/primitives/FormikSelectInput';

import { getInitialValues, validationSchema } from './EditCustomerModal.utils';

import { EditCustomerModalViewProps } from './EditCustomerModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const TYPE = ['Site Owner', 'Concessionaire'];

const EditCustomerModalView: FC<EditCustomerModalViewProps> = (props) => {
  const { isOpen, onClose, onUpdate, customer, isLoading } = props;

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader color="support.500" textAlign="center">
          Edit customer - {customer?._id || ''}
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={getInitialValues(customer)}
              validationSchema={validationSchema}
              onSubmit={onUpdate}>
              {({ isValid }) => (
                <Form>
                  <Flex>
                    <FormikInput
                      name="companyName"
                      label="Company Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <Box h="20px" w="50px" />
                    <FormikSelectInput
                      placeholder="Select a Type"
                      label="Type"
                      name="type">
                      {TYPE?.map((s) => (
                        <option key={s} value={s}>
                          {s || ''}
                        </option>
                      ))}
                    </FormikSelectInput>
                    <Box h="20px" w="50px" />
                    {/* <FormikSelectInput
                      placeholder="Select Wash Hub"
                      label="Wash Hub(*)"
                      name="washHub">
                      {washHubs?.map((w) => (
                        <option key={w._id} value={w._id}>
                          {w?.name || ''}
                        </option>
                      ))}
                    </FormikSelectInput> */}
                  </Flex>
                  <Flex mt={6}>
                    {/* <Flex maxW="250px" w="100%">
                      <FormikSelectInput
                        isLoading={isLoadingSites}
                        placeholder="Select a Site"
                        label="Sites"
                        name="site">
                        {sites?.map((s) => (
                          <option key={s._id} value={s._id}>
                            {s?.name || ''}
                          </option>
                        ))}
                      </FormikSelectInput>
                    </Flex> */}
                    <Flex maxW="250px" w="100%">
                      <FormikInput
                        name="billingContact"
                        label="Billing Contact"
                        labelProps={labelProps}
                        placeholder="your text here"
                      />
                    </Flex>
                    <Box h="20px" w="50px" />
                    {/* <FormikSelectInput
                      placeholder="Select Collection Point"
                      label="Collection Point"
                      name="collectionPoint"
                      isLoading={isLoadingPoints}>
                      {collectionPoints?.map((c) => (
                        <option key={c._id} value={c._id}>
                          {c?.name || ''}
                        </option>
                      ))}
                    </FormikSelectInput> */}
                  </Flex>
                  <Flex my={12} flexDirection="row" justifyContent="center">
                    <Button
                      variant="outline"
                      marginRight="10px"
                      isDisabled={isLoading}
                      w="134px"
                      onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      isDisabled={!isValid}
                      isLoading={isLoading}
                      w="134px">
                      Update
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditCustomerModalView;
